export default "__VITE_ASSET__C4VDs_I9__"